










import { Component, Prop, Vue } from 'vue-property-decorator';
import { deviceApi } from '../device.api';

@Component
export default class DeviceResetSubscriptionToBaseBtn extends Vue {
  @Prop()
  public device: any;

  public get isBtnVisible(): boolean {
    return !this.device.subscriptionConfigSameAsBase && !this.device.deletedAt;
  }

  public async setSubscriptionConfigBackToBase(): Promise<void> {
    try {
      await deviceApi.setSubscriptionConfigBackToBase(this.device.id);
      this.$buefy.snackbar.open({
        message: 'Programmation mise à jour',
        type: 'is-success',
      });
      this.$emit('reset');
    } catch (_) {
      this.$buefy.snackbar.open({
        message: 'Erreur lors du retour à la programmation de base',
        type: 'is-danger',
      });
    }
  }
}
